import { Guid, SerializableObject } from '../../common-react/core';

import { CustomsContentType } from '../other/customs-content-type.enum';
import { ShipmentReturnPolicy } from '../other/shipment-return-policy.enum';

import { CustomsItem } from './customs-item.do';

/**
 * Information on Customs handling for a set of items.
 *
 * @see mobiz-posturinn-extension:Posturinn.Extension.Models.DTO.CustomsInfo
 */
export class CustomsInfo extends SerializableObject {
	public id: Guid;
	public customsContent: CustomsContentType;
	public customsItems: CustomsItem[];
	public returnPolicy?: ShipmentReturnPolicy;

	constructor(json?: unknown) {
		super();
		this.customsItems = [];
		this.buildFromJSON(json);
	}

	protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
		const returnValue: unknown = super.coercePropertyType(propertyName, propertyValue);

		switch (propertyName) {
			case 'customsItems': {
				if (!propertyValue || !Array.isArray(propertyValue)) {
					return [];
				}
				const customsItems: CustomsItem[] = [];
				propertyValue.forEach((partialData: unknown): void => {
					customsItems.push(new CustomsItem(partialData));
				});
				return customsItems;
			}
			default:
				return returnValue;
		}
	}
}
